export const isMLThcdnUrl = (url: string | undefined): boolean => {
  if (!url) return false
  return url.includes('ml.thcdn.com')
}

export const applyPortraitQueryParams = (url: string) => {
  if (!url) return url
  if (url?.includes('?width')) {
    return url
      .replace('?width=300&height=300', '?width=381&height=533')
      .replace('?width=960&height=960', '?width=924&height=1294')
      .replace('?width=70&height=70', '?width=70&height=98')
  }

  return url?.replace('/300', '/381')?.replace('/300', '/533')
}

/**
 * Transform a single image URL to portrait dimensions if it's from ml.thcdn.com
 */
export const transformImageUrl = (url: string | undefined): string => {
  if (!url || !isMLThcdnUrl(url)) {
    return url || ''
  }
  return applyPortraitQueryParams(url)
}

/**
 * Transform all image URLs in an image object (largeProduct, thumbnail, zoom)
 */
export const transformImageObject = <
  T extends {
    largeProduct?: string
    thumbnail?: string
    zoom?: string
  }
>(
  image: T,
): T => {
  if (!image) return image

  const hasMLThcdnUrl =
    isMLThcdnUrl(image.largeProduct) ||
    isMLThcdnUrl(image.thumbnail) ||
    isMLThcdnUrl(image.zoom)

  if (!hasMLThcdnUrl) {
    return image
  }

  return {
    ...image,
    largeProduct: image.largeProduct
      ? applyPortraitQueryParams(image.largeProduct)
      : image.largeProduct,
    thumbnail: image.thumbnail
      ? applyPortraitQueryParams(image.thumbnail)
      : image.thumbnail,
    zoom: image.zoom ? applyPortraitQueryParams(image.zoom) : image.zoom,
  }
}

/**
 * Transform an array of image objects
 */
export const transformImageArray = <
  T extends {
    largeProduct?: string
    thumbnail?: string
    zoom?: string
  }
>(
  images: T[] | undefined | null,
): T[] | undefined => {
  if (!images) return images || undefined

  const hasAnyMLThcdnUrl = images.some(
    (image) =>
      isMLThcdnUrl(image.largeProduct) ||
      isMLThcdnUrl(image.thumbnail) ||
      isMLThcdnUrl(image.zoom),
  )

  if (!hasAnyMLThcdnUrl) {
    return images
  }

  return images.map((image) => transformImageObject(image))
}
